// extracted by mini-css-extract-plugin
export default {"backdrop":"Modal_backdrop__CdlEc","modal":"Modal_modal__48Ytt","slide-down":"Modal_slide-down__AP-C-"};